import { WorkoutFilters } from '../models/workout-filters';
import { matchesWorkoutFilters } from './matches-workout-filters';

interface IAccessParams {
  user: {
    premium: boolean;
    isPaused: boolean;
    isLoggedIn: boolean;
  };
  console: {
    isEmbedded: boolean;
    isClub: boolean;
    workoutFilters: WorkoutFilters;
  };
  dashboardUnlockedWorkoutId: string[];
  workout: {
    id: string;
    subscriptionTypes?: string[];
    workoutFilters: WorkoutFilters;
    isManualWorkout?: boolean;
  };
}

export function isLocked(params: IAccessParams): boolean {
  if (params.workout.isManualWorkout) {
    return false;
  }
  const compatible = matchesWorkoutFilters(
    params.console.workoutFilters,
    params.workout.workoutFilters,
  );
  if (!compatible) {
    return true;
  }
  if (params.dashboardUnlockedWorkoutId?.includes(params.workout.id)) {
    return false;
  }
  if (!params.user.isLoggedIn && params.console.isClub) {
    return false;
  }
  if (params.user.premium && !params.user.isPaused) {
    return false;
  }
  if (!params.console.isEmbedded) {
    return true;
  }
  return !params.workout.subscriptionTypes?.includes('free');
}
